'use client'

import { getLegalLinkHref, LEGAL_LINKS } from '@/entities/legal'
import { SelectCookiesButton } from '@/shared/lib/cookieyes'
import { useI18n } from '@/shared/providers'

import styles from './view.module.css'

export function LegalInfo() {
    const { i18n, lang } = useI18n()

    return (
        <div className={styles.copyright}>
            {i18n.PORTAL_COPYRIGHT_FULL}
            <p>
                {LEGAL_LINKS.map(({ key, path, lang: linkLang }) => {
                    if (linkLang && lang !== linkLang) {
                        return null
                    }

                    return (
                        <a
                            key={key}
                            href={getLegalLinkHref(lang, path)}
                            target="_blank"
                            rel="noreferrer"
                            className={styles.copyrightLink}
                        >
                            {i18n[key]}
                        </a>
                    )
                })}
                <SelectCookiesButton as="a" className={styles.copyrightLink} />
            </p>
        </div>
    )
}
